import NextImage, { ImageProps } from 'next/image';
import { useState } from 'react';

const Image = ({ src: incomeSrc, ...props }: ImageProps) => {
  const srcStr = typeof incomeSrc === 'string' ? incomeSrc : '';
  const hasEnl = srcStr.includes('enl_');

  const [attempt, setAttempt] = useState(0);
  const [trackedSrc, setTrackedSrc] = useState(srcStr);

  if (trackedSrc !== srcStr) {
    setTrackedSrc(srcStr);
    setAttempt(0);
  }

  let resolvedSrc: ImageProps['src'] = '/notFound.png';
  if (attempt === 0) {
    resolvedSrc = hasEnl ? srcStr.replace('enl_', '') : incomeSrc;
  } else if (attempt === 1 && hasEnl) {
    resolvedSrc = incomeSrc;
  }

  return (
    <NextImage
      {...props}
      src={resolvedSrc}
      onError={() => setAttempt((a) => a + 1)}
    />
  );
};

export default Image;
